import { render, staticRenderFns } from "./SupportCalculatorTab.vue?vue&type=template&id=b07b3b76&scoped=true"
import script from "./SupportCalculatorTab.vue?vue&type=script&lang=js"
export * from "./SupportCalculatorTab.vue?vue&type=script&lang=js"
import style0 from "./SupportCalculatorTab.vue?vue&type=style&index=0&id=b07b3b76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b07b3b76",
  null
  
)

export default component.exports